import { PHONE_SUBSCRIPTIONS, PHONE_SUBSCRIPTIONS_NO_SPACE } from './utils/phone';

export const IS_BROWSER = typeof window === 'object' && typeof document === 'object';
export const IS_SERVER = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
export const IS_CLIENT_BUILD = process.env.BUILD_TARGET === 'client';
export const IS_EXPORT_BUILD = process.env.EXPORT === 'true';

const getStringValue = (value, defaultValue = '') => value || defaultValue;

const getBooleanValue = (value, comparisonValue = 'on') => value === comparisonValue;

/**
 * Environment variables
 */
export const ENV = getStringValue(process.env.NODE_ENV);
export const APP_ENV = getStringValue(process.env.APP_ENV);
export const DEV = getBooleanValue(process.env.NODE_ENV, 'development');
export const PROD = getBooleanValue(process.env.NODE_ENV, 'production');
export const PLAYGROUND = getBooleanValue(process.env.PLAYGROUND, 'true');
export const PROXY = DEV || getBooleanValue(process.env.PROXY, 'true');
export const COMPRESS = getBooleanValue(process.env.COMPRESS, 'true');
export const BASIC_AUTH = getBooleanValue(process.env.BASIC_AUTH, 'true');
export const BASIC_AUTH_USER = getStringValue(process.env.BASIC_AUTH_USER);
export const BASIC_AUTH_PASS = getStringValue(process.env.BASIC_AUTH_PASS);
export const VERSION = getStringValue(process.env.RAZZLE_VERSION, '1.0.0');

// URLs
const COMPUTED_API_CLIENT_URL = IS_EXPORT_BUILD ? process.env.RAZZLE_BLINK_API_URL_EXPORT : IS_CLIENT_BUILD ? process.env.RAZZLE_BLINK_API_URL_CLIENT : process.env.RAZZLE_BLINK_API_URL_SERVER;
export const API_CLIENT_URL = getStringValue(COMPUTED_API_CLIENT_URL, 'https://dev-api.blink.cat');
export const REVOLVER_CLIENT_URL = getStringValue(process.env.RAZZLE_REVOLVER_API_URL);
export const GRAPHQL_CLIENT_URL = getStringValue(process.env.RAZZLE_GRAPHQL_API_URL);
export const ASSETS_URL = getStringValue(process.env.RAZZLE_ASSETS_URL);
export const PUBLIC_PATH = getStringValue(process.env.PUBLIC_PATH);
export const DOWNLOAD_LINK_IOS = getStringValue(process.env.RAZZLE_DOWNLOAD_LINK_IOS);
export const DOWNLOAD_LINK_ANDROID = getStringValue(process.env.RAZZLE_DOWNLOAD_LINK_ANDROID);

// Keys/Tokens
export const MAPBOX_TOKEN = getStringValue(process.env.RAZZLE_MAPBOX_TOKEN);
export const STRIPE_KEY = getStringValue(process.env.RAZZLE_STRIPE_KEY);
export const NEWRELIC_ENABLED = getBooleanValue(process.env.RAZZLE_NEWRELIC_BROWSER_ENABLED);
export const NEWRELIC_LICENSE_KEY = getStringValue(process.env.RAZZLE_NEWRELIC_BROWSER_LICENSE_KEY);
export const NEWRELIC_APP_ID = getStringValue(process.env.RAZZLE_NEWRELIC_BROWSER_APP_ID);
export const NEWRELIC_ACCOUNT_ID = getStringValue(process.env.RAZZLE_NEWRELIC_BROWSER_ACCOUNT_ID);
export const USER1ST_ENABLED = getBooleanValue(process.env.RAZZLE_ENABLE_USER1ST_PLUGIN);
export const ROKT_TAG_ID = getStringValue(process.env.RAZZLE_ROKT_TAG_ID);
export const KUSTOMER_CHAT_INIT = getStringValue(process.env.RAZZLE_KUSTOMER_CHAT_INIT);
export const SEGMENT_KEY = getStringValue(process.env.RAZZLE_SEGMENT_KEY);
export const HEAP_ID = getStringValue(process.env.RAZZLE_HEAP_ID);

// Feature flags
export const INPUT_MASKING_ENABLED = getBooleanValue(process.env.RAZZLE_INPUT_MASKING);
export const ENABLE_AUTO_REFILL_RECONSULTATION = getBooleanValue(process.env.RAZZLE_ENABLE_AUTO_REFILL_RECONSULTATION);
export const CMS_META_TAG_ENABLED = getBooleanValue(process.env.RAZZLE_CMS_META_TAG_ENABLED);
export const ENABLE_SCRIPT_NOTIFICATION = getBooleanValue(process.env.RAZZLE_ENABLE_SCRIPT_NOTIFICATION);
export const ENABLE_RELATED_MEDS = getBooleanValue(process.env.RAZZLE_ENABLE_RELATED_MEDS);
export const RAZZLE_ENABLE_AUTOREFILL_CANCELLATION_REASON = getBooleanValue(process.env.RAZZLE_ENABLE_AUTOREFILL_CANCELLATION_REASON);
export const EXECUTIVE_TEAM_PAGE_ENABLED = getBooleanValue(process.env.RAZZLE_ENABLE_EXECUTIVE_TEAM_PAGE);
export const CPE_AR_OUTSIDE_CHECKOUT = getBooleanValue(process.env.RAZZLE_CPE_AR_OUTSIDE_CHECKOUT);
export const ENABLE_TELEHEALTH_SELF_SERVICE_PAUSE = getBooleanValue(process.env.RAZZLE_ENABLE_TELEHEALTH_SELF_SERVICE_PAUSE);
export const ENABLE_CONSULTATION_PRICE_CHANGE = getBooleanValue(process.env.RAZZLE_ENABLE_CONSULTATION_PRICE_CHANGE);
export const ENABLE_UPSHER_SMITH_AR_CHANGE = getBooleanValue(process.env.RAZZLE_ENABLE_UPSHER_SMITH_AR_CHANGE);
export const ENABLE_AMARIN_PURCHASE_OPTIONS = getBooleanValue(process.env.RAZZLE_ENABLE_AMARIN_PURCHASE_OPTIONS);
export const ENABLE_AR_DISCLAIMER = getBooleanValue(process.env.RAZZLE_ENABLE_AR_DISCLAIMER);

/**
 * Static variables
 */
export const REFERRAL_FIRST_FILL_COUPON_MESSAGE = 'Welcome to Blink! Enjoy $15 off your first fill, automatically applied at checkout! ‡';
export const NON_REFERRAL_FIRST_FILL_COUPON_MESSAGE = '<span style="font-weight:300" >Welcome to Blink! Enjoy <strong>$5 OFF</strong> your first order, automatically applied at checkout! ‡</span>';
export const PRIVIA_BANNER_MESSAGE = 'Welcome to Blink Health! We find you the lowest prices for your medications, with or without insurance.';
export const BLINK_HEALTH_PHARMACY_ID = '1063919710';
export const SUBSCRIPTIONS = {
  chatURL: '/account/messages',
  phone: PHONE_SUBSCRIPTIONS,
  phoneRawFormat: PHONE_SUBSCRIPTIONS_NO_SPACE,
};
export const SCRIPT_NOTIFICATION_RATING_SURVEY_ID = 7250;
export const SCRIPT_NOTIFICATION_RATING_SURVEY_RATING_QUESTION_ID = 2100;
export const SCRIPT_NOTIFICATION_RATING_SURVEY_TIME_QUESTION_ID = 2200;
export const FAQ_BASE_URL = 'https://www.blinkhealth-support.com/hc/en-us';
